<template>
    <swiper ref="mySwiper" class="swiper_box"  :options="swiperOptions">
        <!-- 第一页 开始 -->
        <swiper-slide>
           <div class="flex col">
               <div :class="onOff?'yin':'yin1'">
                   <!-- <audio :src="musicUrl" controls="controls" autoplay></audio> -->
               </div>
               <div class="yizu1 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="5s"></div>
               <div class="yizu2 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="5s"></div>
               <div class="yizu3"></div>
            </div> 
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第一页 结束 -->
        <!-- 第二页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="erzu1"></div>
                <div class="erzu2"></div>
                <div class="erzu3"></div>
                <div class="erzu4"></div>
                <div class="erzu5"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第二页 结束 -->
        <!-- 第三页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="sanzu1"></div>
                <div class="sanzu2"></div>
                <div class="sanzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第三页 结束 -->
        <!-- 第四页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="sizu1"></div>
                <div style="margin-top:0.8rem;" class="flex row flex-center">
                    <div class="sizu2"></div>
                    <div class="sizu3"></div>
                </div>
                <div class="sizu4"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第四页 结束 -->
        <!-- 第十八页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shibazu1"></div>
                <div class="shibazu2"></div>
                <div class="shibazu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十八页 结束 -->
        <!-- 第五页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="wuzu1"></div>
                <div class="wuzuList">
                    <div class="wuzu2"></div>
                    <div class="wuzu3"></div>
                </div>
                <div class="wuzu4"></div>
                <div class="wuzuList">
                    <div class="wuzu5"></div>
                    <div class="wuzu6"></div>
                </div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第五页 结束 -->
        <!-- 第六页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="liuzu1"></div>
                <div class="liuzu2"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第六页 结束 -->
        <!-- 第七页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="qizu1"></div>
                <div class="qizu2"></div>
                <div class="qizu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第七页 结束 -->
        <!-- 第八页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="bazu1"></div>
                <div class="bazu2"></div>
                <div class="bazu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第八页 结束 -->
        <!-- 第九页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="jiuzu1"></div>
                <div class="jiuzu2"></div>
                <div class="jiuzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第九页 结束 -->
        <!-- 第十页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shizu1"></div>
                <div class="shizu2"></div>
                <div class="shizu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十页 结束 -->
        <!-- 第十一页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shiyizu1"></div>
                <div class="shiyizu2"></div>
                <div class="shiyizu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十一页 结束 -->
        <!-- 第十二页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shierzu1"></div>
                <div class="shierzu2"></div>
                <div class="shierzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十二页 结束 -->
        <!-- 第十三页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shisanzu1"></div>
                <div class="shisanzu2"></div>
                <div class="shisanzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十三页 结束 -->
        <!-- 第十四页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shisizu1"></div>
                <div class="shisizu2"></div>
                <div class="shisizu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十四页 结束 -->
        <!-- 第十五页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shiwuzu1"></div>
                <div class="shiwuzu2"></div>
                <div class="shiwuzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十五页 结束 -->
        <!-- 第十六页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shiliuzu1"></div>
                <div class="shiliuzu2"></div>
                <div class="shiliuzu3"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十六页 结束 -->
        <!-- 第十七页 开始 -->
        <swiper-slide>
            <div class="flex col">
                <div class="shiqizu1"></div>
                <div class="shiqizu2"></div>
            </div>
            <div class="swiper_logo"></div>
        </swiper-slide>
        <!-- 第十七页 结束 -->
        
        <div class="swiper-pagination" slot="pagination"></div>
        
    </swiper>
</template>
<script>

export default {
    name: "login",
    data(){
        return{
            onOff:false,
            musicUrl:'',
            swiperOptions: {
                effect: 'fade',
                // notNextTick: true,//notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                direction: 'vertical',//水平方向移动
                initialSlide: 0,
                grabCursor: true,//鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
                setWrapperSize: true,//Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                slidesPerView: 1,//设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                mousewheel: false,//开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
                mousewheelControl: false,//同上
                height: window.innerHeight, // 高度设置，占满设备高度
                resistanceRatio: 0,//抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                observeParents: true,//将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
                // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
                onTransitionStart(swiper){
                    console.log(swiper)
                },
                on:{
                    init: function(){
                        swiperAnimateCache(this); //隐藏动画元素 
                        swiperAnimate(this); //初始化完成开始动画
                    }, 
                    slideChangeTransitionEnd: function(){ 
                        swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
                        //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
                    } 
                }
            }
        }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
       this.swiper.slideTo(3, 1000, false)
    },
    methods:{
       
    }
}
</script>
<style scoped>
    
    *{
        padding: 0;
        margin: 0;
    }
    body{
        background: #fff;
    }
    .swiper-slide{
        background: url('../assets/img/bj1.png');
        background-size: 100% 100%;
        position: relative;
    }
    .swiper-slide:nth-child(1){
        background: url('../assets/img/bjLogo.png');
        background-size: 100% 100%;
    }
    .swiper_logo{
        position: absolute;
        top: 0.38rem;
        left: 0.38rem;
        height: 0.8rem;
        width: 0.88rem;
        background: url('../assets/img/logo.png');
        background-size: 100% 100%;
        z-index: 9999;
        transition: all .5s;
    }
    .shibazu1{
        margin: 0 auto;
        margin-top: 1.66rem;
        width: 5.26rem;
        height: 0.92rem;
        background: url('../assets/img/shibazu1.png');
        background-size: 100% 100%;
    }
    .shibazu2{
        margin: 0 auto;
        margin-top: 0.86rem;
        width: 3.71rem;
        height: 3.47rem;
        background: url('../assets/img/shibazu2.png');
        background-size: 100% 100%;
    }
    .shibazu3{
        margin: 0 auto;
        margin-top: 0.8rem;
        width: 6.27rem;
        height: 3.62rem;
        background: url('../assets/img/shibazu3.png');
        background-size: 100% 100%;
    }
    .shiqizu1{
        margin: 0 auto;
        margin-top: 4.96rem;
        width: 3.77rem;
        height: 1.3rem;
        background: url('../assets/img/shiqizu1.png');
        background-size: 100% 100%;
    }
    .shiqizu2{
        margin: 0 auto;
        margin-top: 2.37rem;
        width: 4.89rem;
        height: 3.41rem;
        background: url('../assets/img/shiqizu2.png');
        background-size: 100% 100%;
    }
    .shiliuzu1{
        margin: 0 auto;
        margin-top: 2.15rem;
        width: 4.08rem;
        height: 0.92rem;
        background: url('../assets/img/shiliuzu1.png');
        background-size: 100% 100%;
    }
    .shiliuzu2{
        margin: 0 auto;
        margin-top: 0.78rem;
        width: 6.72rem;
        height: 3.11rem;
        background: url('../assets/img/shiliuzu2.png');
        background-size: 100% 100%;
    }
    .shiliuzu3{
        margin: 0 auto;
        margin-top: 0.78rem;
        width: 6.15rem;
        height: 3.97rem;
        background: url('../assets/img/shiliuzu3.png');
        background-size: 100% 100%;
    }
    .shiwuzu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 5.5rem;
        height: 0.48rem;
        background: url('../assets/img/shiwuzu1.png');
        background-size: 100% 100%;
    }
    .shiwuzu2{
        margin-left: 0.3rem;
        margin-top: 0.37rem;
        width: 6.7rem;
        height: 3.9rem;
        background: url('../assets/img/shiwuzu2.png');
        background-size: 100% 100%;
    }
    .shiwuzu3{
        margin: 0 auto;
        margin-top: 0.52rem;
        width: 6.83rem;
        height: 4.4rem;
        background: url('../assets/img/shiwuzu3.png');
        background-size: 100% 100%;
    }
    .shisizu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 5.5rem;
        height: 0.48rem;
        background: url('../assets/img/shisizu1.png');
        background-size: 100% 100%;
    }
    .shisizu2{
        margin-left: 0.3rem;
        margin-top: 0.55rem;
        width: 6.84rem;
        height: 3.39rem;
        background: url('../assets/img/shisizu2.png');
        background-size: 100% 100%;
    }
    .shisizu3{
        margin: 0 auto;
        margin-top: 0.65rem;
        width: 6.6rem;
        height: 4.97rem;
        background: url('../assets/img/shisizu3.png');
        background-size: 100% 100%;
    }
    .shisanzu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 5.08rem;
        height: 0.48rem;
        background: url('../assets/img/shisanzu1.png');
        background-size: 100% 100%;
    }
    .shisanzu2{
        margin-left: 0.3rem;
        margin-top: 0.56rem;
        width: 6.7rem;
        height: 3.38rem;
        background: url('../assets/img/shisanzu2.png');
        background-size: 100% 100%;
    }
    .shisanzu3{
        margin: 0 auto;
        margin-top: 0.6rem;
        width: 6.39rem;
        height: 4.63rem;
        background: url('../assets/img/shisanzu3.png');
        background-size: 100% 100%;
    }
    .shierzu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 5.08rem;
        height: 0.48rem;
        background: url('../assets/img/shierzu1.png');
        background-size: 100% 100%;
    }
    .shierzu2{
        margin-left: 0.3rem;
        margin-top: 0.55rem;
        width: 4.83rem;
        height: 2.84rem;
        background: url('../assets/img/shierzu2.png');
        background-size: 100% 100%;
    }
    .shierzu3{
        margin: 0 auto;
        margin-top: 0.79rem;
        width: 6.49rem;
        height: 4.71rem;
        background: url('../assets/img/shierzu3.png');
        background-size: 100% 100%;
    }
    .shiyizu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 5.5rem;
        height: 0.48rem;
        background: url('../assets/img/shiyizu1.png');
        background-size: 100% 100%;
    }
    .shiyizu2{
        margin-left: 0.3rem;
        margin-top: 0.64rem;
        width: 6.7rem;
        height: 2.53rem;
        background: url('../assets/img/shiyizu2.png');
        background-size: 100% 100%;
    }
    .shiyizu3{
        margin: 0 auto;
        margin-top: 0.64rem;
        width: 6.44rem;
        height: 5.28rem;
        background: url('../assets/img/shiyizu3.png');
        background-size: 100% 100%;
    }
    .shizu1{
        margin:0 auto;
        margin-top: 1.59rem;
        width: 3.5rem;
        height: 0.91rem;
        background: url('../assets/img/shizu1.png');
        background-size: 100% 100%;
    }
    .shizu2{
        margin:0 auto;
        margin-top: 0.43rem;
        width: 4.36rem;
        height: 2.92rem;
        background: url('../assets/img/shizu2.png');
        background-size: 100% 100%;
    }
    .shizu3{
        margin:0 auto;
        margin-top: 0.63rem;
        width: 7.18rem;
        height: 6.13rem;
        background: url('../assets/img/shizu3.png');
        background-size: 100% 100%;
    }
    .jiuzu1{
        margin-left: 0.3rem;
        margin-top: 2.01rem;
        width: 3.01rem;
        height: 0.48rem;
        background: url('../assets/img/jiuzu1.png');
        background-size: 100% 100%;
    }
    .jiuzu2{
        margin-left: 0.30rem;
        margin-top: 0.33rem;
        width: 6.85rem;
        height: 3.03rem;
        background: url('../assets/img/jiuzu2.png');
        background-size: 100% 100%;
    }
    .jiuzu3{
        margin:0 auto;
        margin-top: 0.63rem;
        width: 5.62rem;
        height: 6.05rem;
        background: url('../assets/img/pym.png');
        background-size: 100% 100%;
    }
    .bazu1{
        margin-left: 0.35rem;
        margin-top: 2.01rem;
        width: 2.58rem;
        height: 0.48rem;
        background: url('../assets/img/bazu1.png');
        background-size: 100% 100%;
    }
    .bazu2{
        margin-left: 0.35rem;
        margin-top: 0.33rem;
        width: 6.7rem;
        height: 3rem;
        background: url('../assets/img/bazu2.png');
        background-size: 100% 100%;
    }
    .bazu3{
        margin:0 auto;
        margin-top: 0.63rem;
        width: 5.57rem;
        height: 5.59rem;
        background: url('../assets/img/bazu3.png');
        background-size: 100% 100%;
    }
    .qizu1{
        margin: 0 auto;
        margin-top: 2.01rem;
        width: 3.5rem;
        height: 0.91rem;
        background: url('../assets/img/qizu1.png');
        background-size: 100% 100%;
    }
    .qizu2{
        margin: 0 auto;
        margin-top: 0.61rem;
        width: 2.84rem;
        height: 0.91rem;
        background: url('../assets/img/qizu2.png');
        background-size: 100% 100%;
    }
    .qizu3{
        margin: 0 auto;
        margin-top: 1.4rem;
        width: 6.92rem;
        height: 6.13rem;
        background: url('../assets/img/qizu3.png');
        background-size: 100% 100%;
    }
    .liuzu1{
       margin-left: 0.4rem;
       margin-top: 2.05rem;
       height: 0.48rem;
       width: 1.75rem;
       background: url('../assets/img/liuzu1.png');
       background-size: 100% 100%;
       margin-bottom: 0.85rem;
    }
    .liuzu2{
       margin-left: 0.4rem;
       height: 6.96rem;
       width: 6.68rem;
       background: url('../assets/img/liuzu2.png');
       background-size: 100% 100%;
    }
    .wuzuList{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.4rem;
        box-sizing: border-box;
    }
    .wuzu1{
       margin-left: 0.4rem;
       margin-top: 2.05rem;
       height: 0.48rem;
       width: 1.75rem;
       background: url('../assets/img/wuzu1.png');
       background-size: 100% 100%;
       margin-bottom: 0.36rem;
    }
    .wuzu2{
        width: 2.98rem;
        height: 2.72rem;
        background: url('../assets/img/wuzu2.png');
        background-size: 100% 100%;
    }
    .wuzu3{
        width: 2.98rem;
        height: 2.72rem;
        background: url('../assets/img/wuzu3.png');
        background-size: 100% 100%;
    }
    .wuzu4{
        margin: 0 auto;
        margin-top: 0.48rem;
        margin-bottom: 0.48rem;
        width: 2.98rem;
        height: 2.72rem;
        background: url('../assets/img/wuzu4.png');
        background-size: 100% 100%;
    }
    .wuzu5{
        width: 2.98rem;
        height: 2.72rem;
        background: url('../assets/img/wuzu5.png');
        background-size: 100% 100%;
    }
    .wuzu6{
        width: 2.98rem;
        height: 2.72rem;
        background: url('../assets/img/wuzu6.png');
        background-size: 100% 100%;
    }
    
    .sizu1{
        margin: 0 auto;
        margin-top: 2.37rem;
        width: 6.84rem;
        height: 4.94rem;
        background: url('../assets/img/sizu1.png');
        background-size: 100% 100%;
    }
    .sizu2{
        margin-right: 0.47rem;
        width: 2.54rem;
        height: 1.93rem;
        background: url('../assets/img/sizu2.png');
        background-size: 100% 100%;
    }
    .sizu3{
        width: 2.54rem;
        height: 1.93rem;
        background: url('../assets/img/sizu3.png');
        background-size: 100% 100%;
    }
    .sizu4{
        margin: 0 auto;
        margin-top: 0.34rem;
        width: 2.54rem;
        height: 1.93rem;
        background: url('../assets/img/sizu4.png');
        background-size: 100% 100%;
    }
    .sanzu1{
        margin: 0 auto;
        margin-top: 2.18rem;
        height: 0.91rem;
        width: 2.35rem;
        background: url('../assets/img/sanzu1.png');
        background-size: 100% 100%;
    }
    .sanzu2{
        margin: 0 auto;
        margin-top: 0.59rem;
        height: 1.58rem;
        width: 1.7rem;
        background: url('../assets/img/sanzu2.png');
        background-size: 100% 100%;
    }
    .sanzu3{
        margin: 0 auto;
        margin-top: 0.75rem;
        height: 6.13rem;
        width: 6.31rem;
        background: url('../assets/img/sanzu3.png');
        background-size: 100% 100%;
    }
    .erzu1{
        margin: 0 auto;
        margin-top: 2.68rem;
        height: 0.83rem;
        width: 1.62rem;background: url('../assets/img/erzu1.png');
        background-size: 100% 100%;
    }
    .erzu2{
       margin: 0 auto;
        margin-top: 0.58rem;
        height: 0.61rem;
        width: 2.42rem;background: url('../assets/img/erzu2.png');
        background-size: 100% 100%; 
    }
    .erzu3{
        margin: 0 auto;
        margin-top: 0.72rem;
        height: 0.61rem;
        width: 3.31rem;background: url('../assets/img/erzu3.png');
        background-size: 100% 100%; 
    }
    .erzu4{
        margin: 0 auto;
        margin-top: 0.72rem;
        height: 0.61rem;
        width: 3.31rem;background: url('../assets/img/erzu4.png');
        background-size: 100% 100%; 
    }
    .erzu5{
        margin: 0 auto;
        margin-top: 0.72rem;
        height: 0.61rem;
        width: 3.75rem;
        background: url('../assets/img/erzu5.png');
        background-size: 100% 100%; 
    }
    .yin{
        position: absolute;
        top: 0.72rem;
        right: 1.14rem;
        height: 0.36rem;
        width: 0.36rem;
        background: url('../assets/img/yin.png');
        background-size: 100% 100%;
        
    }
    .yin1{
        position: absolute;
        top: 0.72rem;
        right: 1.14rem;
        height: 0.36rem;
        width: 0.36rem;
        background: url('../assets/img/yin1.png');
        background-size: 100% 100%;
        
    }
   .yizu1{
       margin: 0 auto;
       margin-top: 2.28rem;
       height: 5.58rem;
       width: 4.1rem;
       background: url('../assets/img/yizu1.png');
       background-size: 100% 100%;
       /* transform: scale(1.1) translateZ(-100px); */
   }
   .yizu2{
       margin: 0 auto;
       margin-top: 0.73rem;
       width: 6.28rem;
       height: 1.28rem;
       background: url('../assets/img/yizu2.png');
       background-size: 100% 100%;
       /* transform: scale(1.1) translateZ(-100px); */
       /* animation: star-ani 2s 1 ease-out; */
   }
   .yizu3{
       margin: 0 auto;
       margin-top: 1.12rem;
       width: 1.82rem;
       height: 1.83rem;
       background: url('../assets/img/yizu3.png');
       background-size: 100% 100%;
       /* transform: scale(1.1) translateZ(-100px); */
   }
   @keyframes star-ani {
        0% {
            opacity: 0;
            transform: scale(0) rotate(0) translate3d(0, 0, 0);
        }
        50% {
            opacity: 0;
            transform: scale(1) rotate(0) translate3d(-100px, 100px, 0);
        }
        100% {
            opacity: 1;
            transform: scale(1) rotate(0) translate3d(0px, 0px, 0);
        }
    }

</style>